import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { STATUS_MAP } from "@/constants/statuses";

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 0) return;
    if (points.length === 1) {
      map.setView([points[0].lat, points[0].lng], 13);
      return;
    }
    const bounds = points.map((p) => [p.lat, p.lng]);
    map.fitBounds(bounds, { padding: [40, 40] });
  }, [points, map]);
  return null;
}

export const MapView = ({ results }) => {
  const points = (results || []).filter(
    (r) => typeof r.lat === "number" && typeof r.lng === "number"
  );

  if (points.length === 0) {
    return (
      <div className="rounded-xl border bg-card p-10 text-center text-sm text-muted-foreground">
        Bu sonuçlar için konum bilgisi yok.
      </div>
    );
  }

  const center = [points[0].lat, points[0].lng];

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-4 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1.5">
          <span className="h-3 w-3 rounded-full" style={{ background: "hsl(24 95% 50%)" }} />
          Lead (web sitesi yok)
        </span>
        <span className="inline-flex items-center gap-1.5">
          <span className="h-3 w-3 rounded-full" style={{ background: "hsl(142 60% 40%)" }} />
          Web sitesi var
        </span>
        <span className="ml-auto">{points.length} işletme haritada</span>
      </div>
      <div
        className="rounded-xl border overflow-hidden shadow-[var(--shadow-card)]"
        style={{ height: "560px" }}
        data-testid="map-view"
      >
        <MapContainer center={center} zoom={11} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <FitBounds points={points} />
          {points.map((b) => {
            const isLead = !b.has_website;
            const color = isLead ? "hsl(24 95% 50%)" : "hsl(142 60% 40%)";
            const st = STATUS_MAP[b.status || "new"];
            return (
              <CircleMarker
                key={b.place_id}
                center={[b.lat, b.lng]}
                radius={9}
                pathOptions={{
                  color: "#ffffff",
                  weight: 2,
                  fillColor: color,
                  fillOpacity: 0.9,
                }}
              >
                <Popup>
                  <div style={{ minWidth: 180 }}>
                    <div style={{ fontWeight: 700, marginBottom: 4 }}>{b.name}</div>
                    <div style={{ fontSize: 12, color: "#555" }}>{b.category || ""}</div>
                    <div style={{ marginTop: 6, fontSize: 12 }}>
                      {isLead ? (
                        <span style={{ color: "hsl(24 95% 35%)", fontWeight: 700 }}>✓ LEAD – web sitesi yok</span>
                      ) : (
                        <a href={b.website} target="_blank" rel="noreferrer">
                          {b.website?.replace(/^https?:\/\//, "")}
                        </a>
                      )}
                    </div>
                    {b.phone && <div style={{ fontSize: 12, marginTop: 4 }}>📞 {b.phone}</div>}
                    {b.email && <div style={{ fontSize: 12, marginTop: 2 }}>✉ {b.email}</div>}
                    <div style={{ marginTop: 6 }}>
                      <span
                        style={{
                          fontSize: 11,
                          padding: "2px 8px",
                          borderRadius: 999,
                          background: st.bg,
                          color: st.fg,
                          fontWeight: 600,
                        }}
                      >
                        {st.label}
                      </span>
                    </div>
                    {b.google_maps_url && (
                      <div style={{ marginTop: 6 }}>
                        <a href={b.google_maps_url} target="_blank" rel="noreferrer">
                          Google Maps’te aç
                        </a>
                      </div>
                    )}
                  </div>
                </Popup>
              </CircleMarker>
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
};
